import { render, staticRenderFns } from "./StockTransRejectDialog.vue?vue&type=template&id=a26bc4c4&scoped=true"
import script from "./StockTransRejectDialog.vue?vue&type=script&lang=js"
export * from "./StockTransRejectDialog.vue?vue&type=script&lang=js"
import style0 from "./StockTransRejectDialog.vue?vue&type=style&index=0&id=a26bc4c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26bc4c4",
  null
  
)

export default component.exports